<!-- eslint-disable -->
<script>
import { createHelpers } from 'vuex-map-fields';
import { mapGetters, mapMutations } from 'vuex';
import clientConfig from '/src/config/client.js';
import asfa from '/src/config/asfaVariables.json';

import NumInput from "../components/helpers/NumInput.vue";
import ToolTip from "../components/helpers/ToolTip.vue";
import {
  MDBRow,
  MDBCol,
  MDBTabs,
  MDBTabNav,
  MDBTabContent,
  MDBTabItem,
  MDBTabPane,
  MDBContainer,
  MDBBtn,
  MDBBtnClose
} from "mdb-vue-ui-kit";

export default {
  components: {
    MDBRow,
    MDBCol,
    MDBTabs,
    MDBTabNav,
    MDBTabContent,
    MDBTabItem,
    MDBTabPane,
    MDBContainer,
    MDBBtn,
    MDBBtnClose,

    NumInput,
    ToolTip,
  },

  data() {
    return {
      clientConfig,
      windowWidth: window.innerWidth,
      activeTabId: "ex1-1",
    }
  },

  mounted() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },

  computed: {
    ...mapGetters([
      "debugMode",
      "activeTab",
      "lastActiveTab",
      "data",
      "appVersion",
    ]),

    lastUpdated: function () {
      const at = new Date(asfa.at);
      const updated = new Date(at.setMonth(at.getMonth() + 3));
      const quarter = `${updated.toLocaleString('default', { month: 'long' })} ${updated.getFullYear()}`;
      return updated > new Date(clientConfig.lastUpdated) ? quarter : clientConfig.lastUpdated;
    }
  },

  methods: {
    ...mapMutations([
      'goToLastVisitedPage', "setIsEditingAssumptions"
    ]),
  },

  watch: {
    isEditingAssumptions() {
      this.activeTabId = this.isEditingAssumptions
        ? ref("ex1-2")
        : ref("ex1-1");
    },
  },

}
</script>

<template>
  <div class='disclaimer-and-assumptions-page'>
    <MDBContainer fluid class="p-0">
      <MDBBtnClose @click="goToLastVisitedPage()" class='btn-close' />
      <div class="content-section">
        <MDBRow class="p-0 pt-3">
          <MDBCol class="mx-auto">
            <MDBRow class="mx-0">
              <MDBCol class="px-0">
                <div v-html="clientConfig.content.disclaimer.content"></div>
                <div v-html="clientConfig.content.assumptions.content"></div>
                <div>
                  <span>Last updated: </span><span v-html="lastUpdated"></span>
                </div>
                <div class="ver text-end pe-2 py-1">
                  <small>v{{ appVersion }}r{{ clientConfig.revision }}</small>
                </div>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </div>
    </MDBContainer>
  </div>
</template>
